import {Component} from "@angular/core";
import {ProductLineSearchModel} from "../product-line-search.model";
import {ProductLineEntityModel} from "../product-line-entity.model";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-product-line-search-page",
    templateUrl: "./product-line-search-page.component.html",
    providers: [
        provideSearchModel(ProductLineSearchModel),
        provideEntityModel(ProductLineEntityModel)
    ]
})
export class ProductLineSearchPageComponent extends AbstractSearchPage {
    public static USAGE_SEARCH_PARAM: string = "usage";

    constructor(public model: ProductLineSearchModel) {
        super();
    }

    prepareInitialFilter(): void {
        if (this.extendedSearchParams && this.extendedSearchParams.searchParams && this.extendedSearchParams.searchParams[ProductLineSearchPageComponent.USAGE_SEARCH_PARAM]) {
            this.model.setFilterValue(ProductLineSearchPageComponent.USAGE_SEARCH_PARAM, this.extendedSearchParams.searchParams[ProductLineSearchPageComponent.USAGE_SEARCH_PARAM]);
        }
    }
}
